/*
 * File: AppointmentDetailRoutes.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 11/11/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: The routes used in the appointment details display
 */

import NextLastAppointmentsPage from "../pages/NextLastAppointments";
import FollowUpsPage from "services/patients/appointments/FollowUps";
import Balances from "services/patients/demographics/balances/Balances";
import Referrals from "services/patients/referrals/Referrals";
import Insurance from "services/patients/insurance_and_guarantors/insurance/Insurance";
import TreatmentsPlannedPage from "../pages/TreatmentsPlanned";
import AppointmentDetailsPage from "../pages/AppointmentDetailsPage";

const AppointmentDetailRoutes = [
  {
    path: "/appointments/:appointmentId",
    component: AppointmentDetailsPage,
    exact: true
  },
  {
    path: "/appointments/:appointmentId/last-next",
    component: NextLastAppointmentsPage,
    exact: true
  },
  {
    path: "/appointments/:appointmentId/followups",
    component: FollowUpsPage,
    exact: true
  },
  {
    path: "/appointments/:appointmentId/treatments-planned",
    component: TreatmentsPlannedPage,
    exact: true
  },
  {
    path: "/appointments/:appointmentId/balances",
    component: Balances,
    exact: true
  },
  {
    path: "/appointments/:appointmentId/referrals",
    component: Referrals,
    exact: true
  },
  {
    path: "/appointments/:appointmentId/insurance",
    component: Insurance,
    exact: true
  }
];

export default AppointmentDetailRoutes;
